import { ApiGroup } from '../types/ApiTypes';

export const LoginHistoryAPI: ApiGroup = {
    pagedList: {
        title: '로그인 이력 목록 조회',
        method: 'POST',
        url: '/LoginHistory/PagedList',
        paramz: {},
    },
    create: {
        title: '로그인 이력 생성',
        method: 'POST',
        url: '/LoginHistory',
        paramz: {},
    },
    getByUserId: {
        title: '사용자 로그인 이력 조회',
        method: 'GET',
        url: '/LoginHistory/User/:userId',
        paramz: {},
    },
};
